import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, EffectFade, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import AddSection from '../Home/AddSection';
import CompetionCaraouselFirst from './CompetionCaraouselFirst';
import { Constants } from '../../shared/constants';


const CompetionCarousel = () => {
    const slides = [
        <CompetionCaraouselFirst />,
        <AddSection bgimg={Constants.customImages.CompetitionCaraouselImg2} title={"Domino Falls"} subTitle={"Activities for kids"} description={"Upgrade your skills with our newest courses, designed to help you excel in your studies and career"} buttonText={"10% Off On Activities"} />
    ];
    return (
        <Swiper
            modules={[Pagination, Autoplay, EffectFade, Navigation]}
            effect="fade"
            spaceBetween={10}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop
            navigation={{ nextEl: ".custom-swiper-next", prevEl: ".custom-swiper-prev" }}
            style={{
                minHeight: "100%",
                borderRadius: "40px",
                position: "relative",
            }}
        >
            {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                    {slide}
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default CompetionCarousel